import {gql} from '@apollo/client';

export const UPDATE_PICKUP_TASK = gql`
  mutation UpdatePickupTask($taskId: String!, $input: PickupTaskInput!) {
    updatePickupTask(taskId: $taskId, input: $input) {
      id
      taskDate
      warehouseId
      routeId
      accountId
      vehicleId
      vehicleModelId
      vehicleTypeId
      startPointType
      startPointValue
      endPointType
      endPointValue
      notes
      status
    }
  }
`; 